/* eslint @typescript-eslint/camelcase: 0 */
import { request } from "api";

export type IndexResponse = {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
};

export type CreateParams = {
  name?: string;
};

export type UpdateParams = CreateParams;

export class Api {
  public static index() {
    return request.get<IndexResponse[]>("/admin/developers");
  }

  public static create(params: CreateParams) {
    return request.post("/admin/developers", params);
  }

  public static update(id: number, params: UpdateParams) {
    return request.post(`/admin/developers/${id}`, params);
  }
}
